import { makeStyles, SvgIcon } from '@material-ui/core'
import logo from './img/logo.png'

export {
  AccountCircleRounded as ProfileIcon,
  CloseRounded as CloseIcon,
  EventNoteRounded as LogsIcon,
  InsertChartRounded as StatsIcon,
  DnsRounded as ServerIcon,
  ExitToAppRounded as SignoutIcon,
  SettingsInputAntennaRounded as MountpointsIcon,
  SupervisedUserCircleRounded as UsersIcon,
  LockOutlined as LockIcon,
  VisibilityRounded as VisibleIcon,
  VisibilityOffRounded as HiddenIcon,
  RefreshRounded as RefreshIcon,
  AddCircle as AddIcon,
  Close as DeleteIcon,
  FiberManualRecordRounded as CircleIcon,
  SearchRounded as SearchIcon,
  GroupWork as PermissionsIcon,
} from '@material-ui/icons'

export function AdminIcon(props: any) {
  return (
    <SvgIcon>
      <path
        fill={props.style.color}
        d="M17,11c0.34,0,0.67,0.04,1,0.09V7.58c0-0.8-0.47-1.52-1.2-1.83l-5.5-2.4c-0.51-0.22-1.09-0.22-1.6,0l-5.5,2.4 C3.47,6.07,3,6.79,3,7.58v3.6c0,4.54,3.2,8.79,7.5,9.82c0.55-0.13,1.08-0.32,1.6-0.55C11.41,19.47,11,18.28,11,17 C11,13.69,13.69,11,17,11z"
      />
      <path
        fill={props.style.color}
        d="M17,13c-2.21,0-4,1.79-4,4c0,2.21,1.79,4,4,4s4-1.79,4-4C21,14.79,19.21,13,17,13z M17,14.38c0.62,0,1.12,0.51,1.12,1.12 s-0.51,1.12-1.12,1.12s-1.12-0.51-1.12-1.12S16.38,14.38,17,14.38z M17,19.75c-0.93,0-1.74-0.46-2.24-1.17 c0.05-0.72,1.51-1.08,2.24-1.08s2.19,0.36,2.24,1.08C18.74,19.29,17.93,19.75,17,19.75z"
      />
    </SvgIcon>
  )
}

export function DistanceIcon(props: any) {
  return (
    <SvgIcon>
      <path
        fill={props.style.color}
        d="M 14.8125 1.9375 C 14.047335 1.9375 13.264277 2.2044733 12.6875 2.78125 L 2.90625 12.59375 C 1.7340816 13.765918 1.6795252 15.70294 2.90625 16.8125 C 2.917603 16.82277 2.92593 16.83363 2.9375 16.84375 L 7.1875 21.09375 C 8.3410534 22.247303 10.252697 22.247303 11.40625 21.09375 L 21.21875 11.3125 C 22.372303 10.158947 22.372303 8.2473034 21.21875 7.09375 L 16.90625 2.78125 C 16.329473 2.2044733 15.577665 1.9375 14.8125 1.9375 z M 14.8125 3.875 C 15.047335 3.875 15.276777 3.9955267 15.5 4.21875 L 19.65625 8.375 L 19.78125 8.5 C 20.227697 8.9464466 20.227697 9.4598034 19.78125 9.90625 L 10 19.6875 C 9.5535534 20.133947 9.0401966 20.133947 8.59375 19.6875 L 4.3125 15.40625 L 4.28125 15.375 L 4.25 15.34375 C 3.911758 15.047788 3.8955162 14.416984 4.3125 14 L 4.71875 13.59375 L 7.15625 16.03125 L 8.21875 14.96875 L 5.78125 12.53125 L 6.71875 11.59375 L 8.15625 13.03125 L 9.21875 11.96875 L 7.78125 10.53125 L 8.71875 9.59375 L 11.15625 12.03125 L 12.21875 10.96875 L 9.78125 8.53125 L 10.71875 7.59375 L 12.15625 9.03125 L 13.21875 7.96875 L 11.78125 6.53125 L 12.71875 5.59375 L 15.15625 8.03125 L 16.21875 6.96875 L 13.78125 4.53125 L 14.09375 4.21875 C 14.316973 3.9955267 14.577665 3.875 14.8125 3.875 z"
      />
    </SvgIcon>
  )
}
export function LogIcon(props: any) {
  return (
    <SvgIcon>
      <g>
        <path
          stroke="null"
          id="svg_1"
          d="m5.87998,12.33271c0,0.02031 0,0.04061 0,0.05907l0.81965,-0.82335a1.23317,1.23317 0 1 1 1.75007,1.73899l-2.81156,2.83371a1.23502,1.23502 0 0 1 -1.72053,0.02769l-2.86879,-2.52173a1.23317,1.23317 0 0 1 1.62454,-1.84607l0.73843,0.65351l0,0a10.02968,10.02968 0 0 1 1.47685,-5.72281a9.70293,9.70293 0 0 1 4.43056,-3.8269a11.10778,11.10778 0 0 1 2.03067,-0.64797a9.70662,9.70662 0 0 1 11.09486,5.73942a10.72011,10.72011 0 0 1 0.64059,2.03067a9.68631,9.68631 0 0 1 -0.24183,4.97515a9.81369,9.81369 0 0 1 -2.68418,4.18319a10.54289,10.54289 0 0 1 -4.16473,2.41835a8.95712,8.95712 0 0 1 -7.47842,-1.08733a1.23317,1.23317 0 0 1 1.34209,-2.06944a6.48339,6.48339 0 0 0 1.02087,0.55382a6.31539,6.31539 0 0 0 1.05226,0.34337a6.54061,6.54061 0 0 0 3.36538,-0.09969a8.08023,8.08023 0 0 0 3.19,-1.87007a7.32889,7.32889 0 0 0 2.01775,-3.14939a7.19966,7.19966 0 0 0 0.18461,-3.7069a8.56206,8.56206 0 0 0 -0.49475,-1.56916a7.23474,7.23474 0 0 0 -8.3073,-4.28657a8.3073,8.3073 0 0 0 -1.57285,0.50213a7.19966,7.19966 0 0 0 -3.31738,2.85033a7.5578,7.5578 0 0 0 -1.11687,4.31795zm5.97756,-4.03919a1.12795,1.12795 0 0 1 2.25589,0l0,3.50753l2.74879,1.5267a1.12425,1.12425 0 1 1 -1.09656,1.96791l-3.24354,-1.80361a1.12795,1.12795 0 0 1 -0.66458,-1.02826l0,-4.17026z"
          fill={props.style.color}
        />
      </g>
    </SvgIcon>
  )
}

export function Logo() {
  const classes = useStyles()
  return <img alt="raycaster" src={logo} className={classes.logo} />
}

const useStyles = makeStyles((theme) => ({
  logo: {
    margin: theme.spacing(0, 1.5),
    width: 24,
    height: 24,
    // [theme.breakpoints.down('xs')]: {
    //   margin: theme.spacing(0),
    // },
  },
}))
